module.exports = __webpack_public_path__ + "media/item-obtain.ea72ea61.mp3";